import * as S from '@effect/schema/Schema';
export const Conditions = S.annotations(S.Array(S.Struct({
    id: S.annotations(S.Number, {
        description: 'ID based on the conditions in the associated Configuration Space',
    }),
    walls: S.annotations(S.Number, {
        description: 'count of walls this can attach to',
    }),
    orientation: S.annotations(S.Literal('left', 'right', 'none'), {
        description: 'orientation of the condition',
    }),
})), {
    description: 'the conditions this model is applicable for',
});
export const Vector3 = S.annotations(S.Struct({ x: S.Number, y: S.Number, z: S.Number }), {
    description: 'a 3D vector',
});
export const AxisAlignedBoundingBox = S.annotations(S.Union(S.Struct({
    min: S.annotations(Vector3, {
        description: 'minimum point of the bounding box',
    }),
    max: S.annotations(Vector3, {
        description: 'maximum point of the bounding box',
    }),
}), S.Null), {
    description: 'the Axis Aligned bounding box of the model',
});
export const Quaternion = S.Struct({ w: S.Number, x: S.Number, y: S.Number, z: S.Number });
export const AttachmentPoints = S.annotations(S.Record({
    key: S.annotations(S.String, {
        description: 'The article ID of the attachment',
    }),
    value: S.Array(S.Struct({
        position: S.annotations(Vector3, {
            description: 'position of the attachment',
        }),
        rotation: S.annotations(Quaternion, {
            description: 'rotation of the attachment',
        }),
        applicableConditions: S.annotations(S.Array(S.annotations(S.Number, {
            description: 'The ID of the condition this attachment should be active for',
        })), {
            description: 'conditions this attachment should be used for',
        }),
    })),
}), {
    description: 'Points on this model where other models can attach',
});
export const OriginDelta = S.annotations(S.Struct({
    applicableConditions: S.annotations(S.Array(S.annotations(S.Number, {
        description: 'The ID of the condition this offset should be active for',
    })), {
        description: 'conditions this offset should be used for',
    }),
    position: S.annotations(Vector3, {
        description: 'position of the offset',
    }),
    rotation: S.annotations(Quaternion, {
        description: 'rotation of the offset',
    }),
}), {
    description: 'The offset of the origin of the model',
});
export const Attachments = S.annotations(S.Struct({
    schemaVersion: S.Literal('1.0.0'),
    originDeltas: S.Array(OriginDelta),
    attachments: AttachmentPoints,
    conditions: Conditions,
    aabb: AxisAlignedBoundingBox,
}), {
    description: 'The entire attachments data for the model',
});
export const parse = S.decodeUnknown(Attachments);
export const parseJson = S.decodeUnknown(S.parseJson(Attachments));
